


namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class WhatIsWhereDepartmentWiseGrid extends _Ext.GridBase<WIPMovementRow, any> {
        protected getColumnsKey() { return 'Production.WhatIsWhereDepartmentWise'; }
        protected getDialogType() { return WIPMovementDialog; }
        protected getIdProperty() { return WIPMovementRow.idProperty; }
        protected getInsertPermission() { return WIPMovementRow.insertPermission; }
        protected getLocalTextPrefix() { return WIPMovementRow.localTextPrefix; }
        protected getService() { return WhatIsWhereService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.addDateRangeFilter("TransDate", "Date");
            this.setTitle("");
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            //grid.registerPlugin(this.autoSize);
            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());


            //this.view.setGrouping([{

            //    getter: 'DeptName',
            //    displayTotalsRow: false,

            //}])

            return grid;
        }

        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();
            var depts = OMS.DepartmentMasterRow.getLookup().items;
            var klass = 'edit numeric readonly';
            for (var i = 0; i < depts.length; i++) {
                var deptname = depts[i].DeptCode;

                columns.push({
                    field: deptname,
                    name: deptname,
                    width: 60,
                    minWidth: 60,
                    maxWidth: 60,
                    format: ctx => {
                        return "<input tabindex='0' type='text' style='text-align: right; width:" + 55 + "px;' class='" + klass +
                            "' data-field='" + deptname +
                            "' value='" + 0 + "' />";
                    }
                });
            }

            for (var j = 0; j < depts.length; j++) {
                let SettingValueColumn = Q.first(columns, x => x.field == depts[j].DeptCode);

                SettingValueColumn.format = ctx => {
                    ctx.value = ctx.item.Pieces;
                    return this.ReadOnlyIntegerInput(ctx, depts);
                }
            }

            return columns;
        }
        public ReadOnlyIntegerInput(ctx, depts) {
            var item = ctx.item;
            var width = (ctx.column.width) as number - 10;
            var returnstring = "";
            for (var i = 0; i < depts.length; i++) {
                var deptname = depts[i].DeptCode;

                if (ctx.column.field != null && ctx.column.field == deptname && ctx.item.DeptCode == deptname)
                    return "<p style='text-align: right; width:" + 55 + "px;' >" + ctx.item.Pieces + "</p>";


            }
            return returnstring;
        }
        // #endregion
        //protected updateInterface() {
        //    super.updateInterface();
        //    this.setTitle("Profit and Loss");
        //}
        protected usePager() { return true; };
        protected getButtons(): Serenity.ToolButton[] { 
            super.getButtons();
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            buttons.push(Common.PdfExportHelper.createToolButton({
                grid: this,
                onViewSubmit: () => this.onViewSubmit(),
                reportTitle: "What is Where(Department Wise)"
            }));

            buttons.push(Common.ExcelExportHelper.createToolButton({
                grid: this,
                service: this.getService() + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            //buttons.push({
            //    title: 'Print',
            //    icon: 'fa fa-print text-blue',
            //    //icon: 'fa-cloud-download',
            //    onClick: () => {

            //        Common.ReportHelper.execute({
            //            reportKey: 'Production.ProfitandLoss',
            //            params: {
            //                CompanyIds: this.view.params.CompanyIds,
            //                FinIds: this.view.params.FinancialYearIds,
            //                VendorIds: this.view.params.VendorIds,
            //                date: this.view.params.Criteria
            //            }
            //        });
            //    }
            //}
            //);
            return buttons;
        }
    }
}

/*
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class WhatIsWhereDepartmentWiseGrid extends Serenity.EntityGrid<WIPMovementRow, any> {
        protected getColumnsKey() { return 'Production.WhatIsWhere'; }
        protected getDialogType() { return WIPMovementDialog; }
        protected getIdProperty() { return WIPMovementRow.idProperty; }
        protected getInsertPermission() { return WIPMovementRow.insertPermission; }
        protected getLocalTextPrefix() { return WIPMovementRow.localTextPrefix; }
        protected getService() { return WhatIsWhereService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            //    this.addDateRangeFilter("TransDate", "Date");
            this.setTitle("");
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            //grid.registerPlugin(this.autoSize);
            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());
         

            this.view.setGrouping([{
              
                getter: 'DeptName',
                displayTotalsRow: false,
               
            }])

            return grid;
        }


        //protected updateInterface() {
        //    super.updateInterface();
        //    this.setTitle("Profit and Loss");
        //}
        protected usePager() { return true; };
        protected getButtons(): Serenity.ToolButton[] {
            super.getButtons();
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            buttons.push(Common.PdfExportHelper.createToolButton({
                grid: this,
                onViewSubmit: () => this.onViewSubmit()
            }));

            buttons.push(Common.ExcelExportHelper.createToolButton({
                grid: this,
                service: this.getService() + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            //buttons.push({
            //    title: 'Print',
            //    icon: 'fa fa-print text-blue',
            //    //icon: 'fa-cloud-download',
            //    onClick: () => {

            //        Common.ReportHelper.execute({
            //            reportKey: 'Production.ProfitandLoss',
            //            params: {
            //                CompanyIds: this.view.params.CompanyIds,
            //                FinIds: this.view.params.FinancialYearIds,
            //                VendorIds: this.view.params.VendorIds,
            //                date: this.view.params.Criteria
            //            }
            //        });
            //    }
            //}
            //);
            return buttons;
        }
    }
}*/